const styles = (theme) => ({
  partnerListItem: {
    color: theme.palette.text.secondary,
    paddingBottom: 18,
  },
});

export default styles;
